import React from 'react';
import { Link } from 'react-router-dom';
import { Text, View } from 'react-native';
import { Button } from '@kds/kid-ui-plus';
import { useLoginStore } from '@/component/LoginSdk/store/useLoginStore';

export default function MyButton() {
    const { loginModelVisible, setLoginModelVisible } = useLoginStore(state => ({
        loginModelVisible: state.loginModelVisible,
        setLoginModelVisible: state.setLoginModelVisible,
    }));
    return (
        <View
            style={{"height":"100vh","fontSize":"4.830917874396135rem"}}>
            <nav>
                <ul>
                    <li>
                        <Link to="/order-confirm?componentName=OrderConfirm&itemId=3117701912&merchantId=912&skuId=3144099912&buyamount=1">
                            order-confirm
                        </Link>
                    </li>
                    <li>
                        <Link to="/detail?itemId=3117701912">detail</Link>
                    </li>
                    <li>
                        <Link to="/address/?referer_page=krnOrderConfirm_1&pageorigin=confirmOrder&entertSource=0&formKrn=1&__launch_options__=%7B%22topBarPosition%22%3A%22fixed%22%7D&hyId=kibt-fe-shop-c-v1&isDefault=1">
                            address
                        </Link>
                    </li>
                    <li>
                        <Link to="/resultV2">resultV2</Link>
                    </li>
                </ul>
            </nav>
            <Button onPress={() => setLoginModelVisible(true)}>打开登录弹窗</Button>
        </View>
    );
}
